import { render, staticRenderFns } from "./AdminIssues.vue?vue&type=template&id=703f43ea&"
import script from "./AdminIssues.vue?vue&type=script&lang=js&"
export * from "./AdminIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports